<template>
  <div v-if="notMonitored" class="not-monitored">
    <div class="title">该直播暂未被监控</div>
    <div class="description">添加直播监控后，系统会立即跟踪该达人直播和带货数据</div>
    <div class="btn" @click="$emit('monitor')">添加监控</div>
  </div>
  <div id="shopAnalysis" v-else>
    <SwitchCalendar v-model="timeYYYYMMDD" :shortcuts="shortcuts" class="switchCalendar" :availableDate="availableDate"/>
    <div class="divider" />
    <staticDataBox :data="staticData" />
    <SwitchRadio class="mt-24 mb-8" :list="[{name: '商品列表',value: 'List'},{name: '商品分析',value:'Analysis'}]" v-model="display"/>
    <!--  商品列表与分析  -->
      <keep-alive v-if="isVip">
        <component :is="display" :time="time" />
      </keep-alive>
      <DredgeVipDefault v-else />
  </div>
</template>

<script>
import Analysis from "./Analysis";
import List from './List';
import SwitchRadio from './components/SwitchRadio'
import staticDataBox from "@/modules/anchor/ShopAnalysis/staticDataBox";
import moment from "moment";


export default {
  components: { Analysis, List,SwitchRadio,staticDataBox },
  data() {
    return {
      staticData:{}, // 统计数据
      display: 'List', // 切换module
      timeYYYYMMDD: [moment().subtract(7,'days').format('YYYYMMDD'),moment().subtract(1,'days').format('YYYYMMDD')],
    };
  },
  mounted() {
    this.$store.commit('WRITEOVERLAYSHOW', { textChange: 'shopAnalysis' }) // 挂在修改文案
  },
  computed:{
    time:(_this = this) => (_this.timeYYYYMMDD.map( ele => moment(ele).unix())),
    isLogin: (_this = this) => !!_this.$store?.state?.userInfo?.id,
    isVip: (_this = this) => _this.$store.state.userInfo && _this.$store.state.userLevel <= 96,
    isProVip:(_this = this) => _this.$store.state.userInfo && _this.$store.state.userLevel <= 95,
    isSuperVip: (_this = this) => _this.$store.state.userInfo && _this.$store.state.userLevel <= 90,
    shortcuts: (_this = this) => ([
      { name:'7天', value: 7  },
      { name:'30天', value: 30 },
      { name:'90天', value: 90 ,disabled: !_this.isProVip,clickEmit: (event) =>{ event && _this.disabled() }  },
      { name:'180天', value: 180 ,disabled: !_this.isSuperVip,clickEmit: (event) =>{ event && _this.disabled() }  },
    ]),
    availableDate(){
      if(this.isSuperVip) return 180
      if(this.isProVip) return 90
      return 30
    },
    /** 未监控 */
    notMonitored: (_this = this) => false
  },
  watch:{
    time:{
      immediate:true,
      handler(){this.getStaticData() }
    }
  },
  methods: {
    disabled(){
      this.$store.commit('WRITEOVERLAYSHOW', { textChange: 'commodityAnalysis',status: true})
    },
    async getStaticData(){
      this.$showLoading()
      const params = { time:`$between:[${this.time[0]},${this.time[1]}]` }
      this.staticData = await this.$api.get(`/v2/anchor/${this.$route.params.id}/liveStreamCommodityStatistic` ,{params:params}).catch( _ => ({})).then( _ => (_?.data || {}))
      this.$hideLoading()
    }
  }
};
</script>

<style lang="less" scoped>
.not-monitored {
  text-align: center;
  padding: 1.5rem 0.75rem 1rem;

  .title {
    color: #4a4a4a;
    margin-bottom: 0.3rem;
  }

  .description {
    color: #a1aebf;
    line-height: 0.48rem;
    margin-bottom: 0.56rem;
  }

  .btn {
    width: 3rem;
    height: 1rem;
    border-radius: 0.08rem;
    margin: 0 auto;
    background: linear-gradient(180deg, #ffc900 0%, #ff9900 100%);
    font-size: 0.36rem;
    line-height: 1rem;
    color: white;
  }
}
#shopAnalysis {
  padding: 0 12px;
  background: white;
  .switchCalendar{
    padding-top: 12px;
  }
  .divider{
    height: 0.5px;
    width: 100%;
    margin-top: 16px;
    margin-bottom: 12px;
    background: #EDEDEE;
  }
  .mt-24{
    margin-top: 24px;
  }
  .mb-8{
    margin-bottom: 8px;
  }
}
</style>